import React from 'react';
import PropTypes from 'prop-types';

import LiveList from 'components/Pages/Menu/MenuItemContent/LiveList';
import PrematchList from 'components/Pages/Menu/MenuItemContent/PrematchList';

const MenuItemChild = ({ activeItem }) => {
  if (activeItem === 'Sport') {
    return <PrematchList />;
  }

  if (activeItem === 'Live') {
    return <LiveList />;
  }

  return null;
};

MenuItemChild.propTypes = {
  activeItem: PropTypes.string,
};

export default MenuItemChild;
